import { ITitle } from '@/components/BuilderIO/common/CommonFields';
import Title from '@/components/Title/Title';

interface BoxWidgetProps {
  /**
   * Optional large header.
   * - content*: The content of the header
   * - titleHTMLTag: Heading level that will be used to render the optional header. Defaults to 'h2'
   * - titleSize: Select one of the styles 'extraLarge' | 'large' | 'medium' | 'small'.
   * - titleWeight: Optional header weight. Defaults to 'normal'
   */
  optionalLargeHeader: ITitle;
  /*
   * Title description for users with screen readers
   */
  title?: string;
}

export default function BoxWidget({ optionalLargeHeader, title = 'Box Widget' }: BoxWidgetProps) {
  return (
    <div className="container wrapper tw-mb-[20px] tw-px-[15px] xl:!tw-w-full xl:!tw-max-w-[1030px]">
      {optionalLargeHeader?.content && (
        <Title
          component={optionalLargeHeader?.titleHTMLTag || 'h2'}
          size={optionalLargeHeader?.titleSize}
          weight={optionalLargeHeader?.titleWeight}
          alignment="center"
          className="!tw-mb-[20px] !tw-mt-[10px]"
        >
          {optionalLargeHeader?.content}
        </Title>
      )}
      <div className="diamond_card tw-flex tw-flex-col tw-items-center">
        <script
          src="https://brilliantearth.app.box.com/upload-widget/embed.js?folderID=8296192461&title=CUSTOMER%20SUPPORT%20FORM%20SUBMISSION&instructions=Submit%20File%20to%20CSS&isDescriptionFieldShown=1&isEmailRequired=1&width=385&height=420&token=kimt2g3smpwr005zfoa92c2m9q8fi54j"
          type="text/javascript"
        />
        <iframe
          title={title}
          id="box-upload-widget-iframe-xfvffyucolq"
          src="https://brilliantearth.app.box.com/upload-widget/view/kimt2g3smpwr005zfoa92c2m9q8fi54j/8296192461?height=420&amp;instructions=Submit+File+to+CSS&amp;title=CUSTOMER+SUPPORT+FORM+SUBMISSION&amp;isDescriptionFieldShown=1&amp;isEmailRequired=1"
          height="453"
          className="tw-border-none tw-w-full tw-max-w-[400px] xl:tw-w-[40%]"
        />
      </div>
    </div>
  );
}
